module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lift-edit"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group",
    staticStyle: {
      "align": "left"
    }
  }, [_c('label', {
    staticClass: "control-label col-sm-2"
  }, [_vm._v("MAC")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8",
    attrs: {
      "id": "app_name"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mac),
      expression: "mac"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "mac",
      "id": "mac",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.mac)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mac = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "align": "left"
    }
  }, [_c('label', {
    staticClass: "control-label col-sm-2"
  }, [_vm._v("描述")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.desc),
      expression: "desc"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "desc",
      "id": "desc",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.desc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.desc = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "align": "left"
    }
  }, [_c('label', {
    staticClass: "control-label col-sm-2"
  }, [_vm._v("安装位置")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "select-input"
    }
  }, [_c('select', {
    staticClass: "your-selector form-control",
    on: {
      "change": function($event) {
        return _vm.test($event)
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(" - ")]), _vm._v(" "), _vm._l((_vm.level1Addrs), function(addr) {
    return _c('option', {
      domProps: {
        "value": addr.addr_id
      }
    }, [_vm._v(_vm._s(addr.description))])
  })], 2)]), _vm._v(" "), _c('span', {
    staticClass: "addr-span"
  }, [_vm._v(_vm._s(_vm.addrLabel(_vm.addrs)))]), _vm._v(" "), _c('span', {
    attrs: {
      "id": "new-addr-span"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn green small pull-right",
    attrs: {
      "type": "button",
      "id": "btn-edit"
    },
    on: {
      "click": _vm.edit
    }
  }, [_c('i', {
    staticClass: "fa fa-edit"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "display": "none",
      "margin-top": "2px"
    },
    attrs: {
      "id": "btn-ctrl"
    }
  }, [_c('button', {
    staticClass: "btn green small",
    attrs: {
      "type": "button",
      "id": "btn-edit"
    },
    on: {
      "click": _vm.ensure
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn grey small",
    attrs: {
      "type": "button",
      "id": "btn-edit"
    },
    on: {
      "click": _vm.discard
    }
  }, [_c('i', {
    staticClass: "fa fa-remove"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "align": "left"
    }
  }, [_c('label', {
    staticClass: "control-label col-sm-2"
  }, [_vm._v("安装时间")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.createTimeStr))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "align": "left"
    }
  }, [_c('label', {
    staticClass: "control-label col-sm-2"
  }, [_vm._v("楼层")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('table', {
    staticClass: "table table-bordered table-condensed"
  }, [_c('tbody', [_vm._l((_vm.floorGroup), function(item) {
    return [_c('tr', _vm._l((item), function(it) {
      return _c('th', [_vm._v(_vm._s(it.io_index))])
    }), 0), _vm._v(" "), _c('tr', _vm._l((item), function(it) {
      return _c('td', [_vm._v(_vm._s(it.label))])
    }), 0)]
  })], 2)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isError),
      expression: "isError"
    }],
    staticClass: "animated alert alert-danger",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "tip-alert",
      "role": "alert"
    }
  }, [_vm._v("数据填写不完整！")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button",
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('button', {
    staticClass: "btn blue btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("确定")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2ec9b903!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiftDetail.vue
// module id = 297
// module chunks = 2 3